import { render } from "./FutureAppointments.vue?vue&type=template&id=a5d60e90"
import script from "./FutureAppointments.vue?vue&type=script&lang=js"
export * from "./FutureAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__